export function filterMonthTitle(input) {
  if (!input) return "";
  const parts = input.split("-").map(Number);
  if (parts.length < 2 || parts.some(isNaN)) return "";
  const [year, month] = parts;
  const dateObj = new Date(year, month - 1, 1);
  return dateObj.toLocaleDateString("en-US", {
    month: "short",
  });
}